module.exports = __webpack_public_path__ + "static/media/cog.5023084a.jpg";